<template lang="pug">
    <div class="dragger">
        <div class="dragger--handler hover_audio">
            <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
            <path fill="#ffed00" d="M298.3 256L131.1 81.9c-4.2-4.3-4.1-11.4.2-15.8l29.9-30.6c4.3-4.4 11.3-4.5 15.5-.2L380.9 248c2.2 2.2 3.2 5.2 3 8.1.1 3-.9 5.9-3 8.1L176.7 476.8c-4.2 4.3-11.2 4.2-15.5-.2L131.3 446c-4.3-4.4-4.4-11.5-.2-15.8L298.3 256z"/>
            </svg>
        </div>
        <div class="dragger--info" v-if="!$store.state.everDragged">
            <strong>Click and drag</strong>
        </div>
    </div>
</template>
<script>
import Draggable from 'gsap/Draggable'
import { TweenMax } from 'gsap'
let tl = new TimelineLite()
export default {
    data() {
        return {
        }
    },
    mounted() {
        console.log('dragger mounted')
        var draggScene = Draggable.create('.dragger--handler', {
                type: 'left',
                edgeResistance: 0,
                bounds: parent,
                liveSnap: false,
                onDragStart: this.dragStarted,
                onDragEnd: this.dragEnded,
                onDrag: this.drag
            })
        tl.fromTo('.dragger', 3, 
            { opacity: 0, xPercent: '-100', yPercent:'-50', ease: Power4.easeOut }, 
            { opacity: 1, xPercent: '-50', yPercent:'-50'})
          .fromTo('.dragger--info', 4,
            { yPercent: '-100', opacity: 0, ease: Power4.easeOut },
            { yPercent: '-40', opacity: 1 }, '-=1')

        this.$store.commit('anatomy', false)
        this.$store.commit('draggerOpen', true)
    },
    methods: {
        dragStarted() {
            let self = document.querySelector('.dragger--handler')
            self.classList.add('is-active')
            TweenMax.to('.dragger--info', 1, { opacity: 0, ease: Power4.easeOut })
        },
        dragEnded() {
            let ww = document.querySelector('body').clientWidth
            let self = document.querySelector('.dragger--handler')
            let rightPos = self.getBoundingClientRect().right
            let thisss = this
            if (rightPos > (ww * 0.75)) {
                tl
                    .to(self, 4, { left: ww * 1.5, ease: Power4.easeOut })
                    .to(self, 0.75, { opacity: 0, ease: Power0.easeOut, onComplete: () => {
                        thisss.$emit('draggerDone')
                        thisss.$store.commit('anatomy', true)
                        thisss.$store.commit('draggerOpen', false)
                        thisss.$store.commit('everDragged', true)
                        tl.eventCallback("onComplete", null);
                        tl.eventCallback("onUpdate", null);
                        tl.eventCallback("onStart", null);
                        tl.kill()
                    } }, '-=2')
            } else {
                tl.to(self, 0.75, { left: 0, ease: Back.easeOut } )
                TweenMax.to('.dragger--info', 1, { opacity: 0.75, ease: Power4.easeIn })
            }
        }
    },
    beforeDestroy() {
        console.log('Dragger before destroy')
    }
}
</script>
<style lang="scss" scoped>
.dragger {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dragger.vue